import { Shapefile } from "components/project/shapefiles/queries";

export function getUncheckedFeatures(
  layerName: string,
  shapefileFeatures,
  shapefile: Shapefile
): string[] {
  if (shapefileFeatures?.[layerName]?.features) {
    let uncheckedFeatures = shapefileFeatures?.[layerName]?.features
      .filter((f) => f.checked)
      .map((f) => f.shapefileGeomId);
    if (!uncheckedFeatures?.length) {
      uncheckedFeatures = [""];
    }
    return uncheckedFeatures;
  }

  // Both GeoJSON and Shapetile APIs return features with shapefileGeomId in properties
  return (
    shapefile.featureCollection?.features?.map(
      (f) => f.properties?.shapefileGeomId as string
    ) ||
    shapefile.features?.map((f) => f.shapefileGeomId) ||
    []
  );
}
